import { render, staticRenderFns } from "./IconRightBlue.vue?vue&type=template&id=15f2649b&scoped=true&"
import script from "./IconRightBlue.vue?vue&type=script&lang=js&"
export * from "./IconRightBlue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f2649b",
  null
  
)

export default component.exports